<template>
   <v-form>
      <v-card-title class="modal-cadastro-titulo">
        Promtores
      </v-card-title>
    
      <v-card-text class="modal-cadastro-form">
        <v-row>
          <v-col cols="12">
            <autoCompleteEntities :entityProps.sync="entity" :entityId="entityId" :typesEntities="['3']" :label="'Promotor'" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="modal-cadastro-footer">
        <v-btn :color="variables.colorPrimary" class="br-btn br-btn-cancelar">Cancelar</v-btn>
        <v-btn type="submit" :color="variables.colorPrimary"  @click.prevent="submit" class="br-btn">{{ 'Cadastrar' }}</v-btn>
      </v-card-actions>
    </v-form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { mask } from 'vue-the-mask'
import variables from '@/assets/styles/helpers/_variables.scss'

export default {
  name: 'Promotores',
  mixins: [validationMixin],
  directives: {
    mask
  },

  props: {
    entityId: {
      type: Number,
      default: null
    }
  },

  components: {
    autoCompleteEntities: () => import('@/views/components/autoCompleteEntities/userPromotor'),
  },

  data: () => ({
    entity: {},
  }),

  mounted () {
  },
  computed: {
    variables: () => variables,
  },
  methods: {

    submit () {
      this.$emit('cadastrar', this.entity)
    },
  }
}
</script>

<style>

</style>